<template>
	<div class="select_container">
		<select
			ref="selectMenu"
			@change="handleSelect($event)"
			:id="name"
			:name="name"
		>
			<option selected disabled value>Choose an option...</option>
			<template v-if="name === 'binding'">
				<option
					v-for="(option, index) in store.bindingOptions"
					:disabled="option.disabled"
					:multiplier="option.multiplier"
					:coating="option.coating"
					:value="option.name"
					:key="index"
					>{{ option.name }}</option
				>
			</template>
			<template v-else-if="name === 'coating'">
				<option
					v-for="(option, index) in compatibleCoatingOptions"
					:multiplier="option.multiplier"
					:value="option.name"
					:key="index"
					>{{ option.name }}</option
				>
			</template>
			<template v-else-if="name === 'size'">
				<option
					v-for="(option, index) in data.options"
					:multiplier="option.multiplier"
					:width="option.width"
					:height="option.length"
					:value="option.name"
					:key="index"
					>{{ option.name }}</option
				>
			</template>
			<template v-else-if="name === 'paper' || name === 'cover_paper'">
				<option
					v-for="(option, index) in data.options"
					:multiplier="option.multiplier"
					:weight="option.weight_per_sheet"
					:cover="option.is_cover_stock || 'false'"
					:value="option.name"
					:key="index"
					>{{ option.name }}</option
				>
			</template>
			<template v-else>
				<option
					v-for="(option, index) in data.options"
					:selected="index === data.selected_index"
					:multiplier="option.multiplier"
					:value="option.name"
					:key="index"
					>{{ option.name }}</option
				>
			</template>
		</select>
	</div>
</template>

<script>
import { store, mutations } from "../store";

export default {
	data() {
		return {
			store: store
		};
	},

	computed: {
		compatibleCoatingOptions() {
			return this.data.options.filter(
				o => store.coatingOptions.indexOf(o.name) > -1
			);
		}
	},

	methods: {
		handleSelect(e) {
			let val = +e.target.selectedOptions[0].getAttribute("multiplier");
			let selection = e.target.selectedOptions[0].getAttribute("value");

			switch (this.name) {
				case "binding":
					mutations.setBindingCharge(val);
					mutations.setBindingName(selection);
					mutations.setCompatibleCoating(e);
					break;

				case "blank_envelope":
					mutations.setBlankEnvelopeCharge(val);
					break;

				case "bleed":
					mutations.setBleedCost(val);
					break;

				case "coating":
					mutations.setCoatingCharge(val);
					break;

				case "corner_rounding":
					mutations.setCornerRoundingCharge(val);
					break;

				case "cover_ink":
					mutations.setCoverInkCharge(val);
					break;

				case "cover_paper":
					mutations.setCoverPaperCharge(val);
					mutations.setCoverPaperWeight(e);
					break;

				case "folding":
					mutations.setFoldingCharge(val);
					break;

				case "hole_punching":
					mutations.setDrillingCharge(val);
					break;

				case "ink":
					mutations.setClickCharge(val);
					break;

				case "orientation":
					mutations.setLandscapePremium(val);
					break;

				case "padding":
					mutations.setPadding(val);
					break;

				case "paper":
					mutations.setPaperCharge(val);
					mutations.setPaperIsCover(e);
					mutations.setPaperWeightPerSheet(e);
					break;

				case "plastic_coil_color":
					mutations.setCoilPlasticColorCharge(val);
					break;

				case "plastic_cover_back":
					mutations.setCoverBackCharge(val);
					break;

				case "plastic_cover_front":
					mutations.setCoverFrontCharge(val);
					break;

				case "proof":
					mutations.setProofCharge(val);
					break;

				case "shrink_wrap":
					mutations.setShrinkWrapCharge(val);
					break;

				case "size":
					mutations.setSizeFactor(val);
					mutations.setSizeSquareInches(
						e.target.selectedOptions[0].getAttribute("width"),
						e.target.selectedOptions[0].getAttribute("height")
					);
					break;

				case "speed":
					mutations.setProductionCost(val);
					break;

				case "wireo_color":
					mutations.setCoilWireoColorCharge(val);
					break;
			}

			this.$emit("select-changed", val);
		}
	},

	mounted() {
		if (this.name === "binding") {
			mutations.setBindingOptions(this.data.options);
			// mutations.disableIncompatibleBinding(store.pages);
		}

		if (this.name === "coating") {
			mutations.setCoatingOptions(this.data.options);
		}
	},

	props: {
		data: {
			type: Object,
			required: true
		},

		name: {
			type: String,
			required: true
		}
	},

	updated() {
		// resets coating selection when a new binding selection is made
		if (this.name === "coating") {
			let selectBox = this.$refs.selectMenu;

			if (selectBox.options[selectBox.selectedIndex].value) {
				selectBox.options[1].selected = true;
				selectBox.dispatchEvent(new Event("change"));
			}
		}

		/**
		 *	If the currently selected binding option is disabled (e.g., b/c page count is too high),
		 *	update the binding selection to the next available option
		 */
		if (this.name === "binding" && store.bindingOptions.length) {
			let selectBox = this.$refs.selectMenu;

			if (selectBox.options[selectBox.selectedIndex].disabled === true) {
				selectBox.options[selectBox.selectedIndex + 1].selected = true;
				selectBox.dispatchEvent(new Event("change"));
			}
		}
	}
};
</script>
